module.exports = __webpack_public_path__ + "static/media/bribery.1ed4aa06.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/bribery.png
// module id = 1589
// module chunks = 0